import { render, staticRenderFns } from "./PagesSummaryRow.vue?vue&type=template&id=4204d51d&"
import script from "./PagesSummaryRow.vue?vue&type=script&lang=js&"
export * from "./PagesSummaryRow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports